<template>
  <v-list style="min-width: 250px" class="bg-background rounded-lg pa-3">
    <v-list-item>
      <v-row no-gutters>
        <v-avatar color="pwt_gainsboro" class="mr-3 mt-1">
          <img v-if="avatarSrc" :src="avatarSrc" width="100%" height="auto" />
          <v-icon v-else color="pwt_light_grey"> mdi-account-circle </v-icon>
        </v-avatar>
        <v-card-subtitle class="d-flex flex-column text-pwt_black pt-0">
          <span class="font-weight-medium text-h6">
            {{ user ? user.fullName : '' }}
          </span>
          <span>
            {{ user ? user.email : '' }}
          </span>
        </v-card-subtitle>
        <v-spacer />
      </v-row>
    </v-list-item>
    <v-divider class="mb-3" />
    <v-list-item @click="handleChangeDashboardTab('account')">
      <v-list-item-title> Manage account </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('fleet-vehicles')">
      <v-list-item-title> My fleet </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('vehicle-details')">
      <v-list-item-title> Vehicle settings </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('defaults')">
      <v-list-item-title> Trip planning defaults </v-list-item-title>
    </v-list-item>
    <v-divider class="mb-3" />
    <v-list-item @click="authHandler">
      <v-list-item-title
        class="text-decoration-underline text-accent"
        style="text-underline-offset: 4px"
      >
        {{ isAuthorised ? 'Sign out' : 'Sign in' }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script lang="ts" setup>
import Driver from '@/classes/user_classes/driver'
import keycloak from '@/keycloak'
import {
  ActionTypes,
  type DashboardDialogContent,
  GettersTypes,
  MutationTypes,
  type State,
} from '@/store/store_types'
import getAssetSrc from '@/utils/getAssetSrc'
import { computed } from 'vue'
import { useStore } from 'vuex'

const emit = defineEmits(['close'])
const store = useStore<State>()

const driver = computed<Driver | undefined>(() => store.getters[GettersTypes.currentDriver])
const user = computed(() => store.state.user)
const avatarSrc = computed(() => driver.value?.profilePicSrc ?? getAssetSrc('No account icon.svg'))
const isAuthorised = computed(() => store.state.authorizedFlag)

function authHandler() {
  if (isAuthorised.value) {
    handleLogout()
  } else {
    handleLogin()
  }
}

function handleLogout() {
  emit('close')
  store.dispatch(ActionTypes.logoutUser)
}

function handleLogin() {
  const redirectUri =
    window.location.origin +
    '/#/login/' +
    new URLSearchParams(
      'location=' +
        (window.location.hash.includes('location=')
          ? window.location.hash.replace(/&location=.*/, '')
          : window.location.hash) +
        '&' +
        window.location.search,
    ).toString()

  keycloak.login({
    redirectUri,
  })
}

function handleChangeDashboardTab(tab: DashboardDialogContent) {
  store.commit(MutationTypes.setDashboardDialogContent, tab)
  emit('close')
}
</script>
